import { AuditMarkerTotal } from '../models';
import * as St from '../styles';
import { formatNumber, formatPercent } from '../utils';
import CardStatus, { CardStatusProps } from './CardStatus';

const MARKER_STYLE: Record<string, { label: string; color: string }> = {
  PERMITIDO: { label: 'Permitido', color: '#5fb976' },
  NEGADO: { label: 'Negado', color: '#f39433' },
  SEM_REGISTRO: { label: 'Sem registro', color: '#6b7280' },
};

const AppMarkers: React.FC<
  { markers?: AuditMarkerTotal[] } & CardStatusProps
> = ({ markers = [], loading, error }) => (
  <St.Card muted padding={25}>
    <St.MarkersBar>
      <St.CardTitle>
        <h3>Marcadores da aplicação</h3>
        <span>PERMITIDO e NEGADO não equivalem ao status HTTP</span>
      </St.CardTitle>
      <CardStatus loading={loading} error={error} height={40}>
        <St.MarkersList>
          {markers.map((marker) => {
            // Valores inesperados vêm depois dos três fixos; exibe o valor cru.
            const style = MARKER_STYLE[marker.marcador] ?? {
              label: marker.marcador,
              color: '#c1c1c1',
            };
            return (
              <St.Marker key={marker.marcador} color={style.color}>
                <span>{style.label}</span>
                <b>{formatNumber(marker.total)}</b>
                <small>{formatPercent(marker.percentual)}</small>
              </St.Marker>
            );
          })}
        </St.MarkersList>
      </CardStatus>
    </St.MarkersBar>
  </St.Card>
);

export default AppMarkers;
